import { render, staticRenderFns } from "./PlansView.vue?vue&type=template&id=34a12c28&scoped=true&"
import script from "./PlansView.vue?vue&type=script&lang=js&"
export * from "./PlansView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a12c28",
  null
  
)

export default component.exports